//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeProductPage, storeProductReplyPage, storeProductReplyVirtual, storeProductReplyComment, storeProductReplyDelete } from '@/api/distributionStore';
export default {
  name: 'DistributionStoreReply',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      rows: [],
      products: [],
      total: 0,
      query: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        star: null,
        isReply: null
      },
      form: this.emptyForm(),
      rules: {
        productId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        nickname: [{
          required: true,
          message: '请输入评论人昵称',
          trigger: 'blur'
        }],
        star: [{
          required: true,
          message: '请选择星级',
          trigger: 'change'
        }],
        comment: [{
          required: true,
          message: '请输入评论内容',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    emptyForm: function emptyForm() {
      return {
        productId: null,
        attrValueId: 0,
        sku: '',
        star: 5,
        comment: '',
        pics: [],
        nickname: '',
        avatar: ''
      };
    },
    load: function load() {
      var _this = this;
      this.loading = true;
      storeProductReplyPage(this.query).then(function (res) {
        _this.rows = res.list || [];
        _this.total = Number(res.total) || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    search: function search() {
      this.query.page = 1;
      this.load();
    },
    reset: function reset() {
      this.query = {
        page: 1,
        limit: this.query.limit,
        keywords: '',
        star: null,
        isReply: null
      };
      this.load();
    },
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    sizeChange: function sizeChange(limit) {
      this.query.limit = limit;
      this.query.page = 1;
      this.load();
    },
    openVirtual: function openVirtual() {
      var _this2 = this;
      this.form = this.emptyForm();
      storeProductPage({
        page: 1,
        limit: 100,
        status: 1
      }).then(function (res) {
        _this2.products = res.list || [];
        _this2.visible = true;
      });
    },
    submitVirtual: function submitVirtual() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this3.saving = true;
        storeProductReplyVirtual(_this3.form).then(function () {
          _this3.$message.success('添加成功');
          _this3.visible = false;
          _this3.load();
        }).finally(function () {
          _this3.saving = false;
        });
      });
    },
    reply: function reply(row) {
      var _this4 = this;
      this.$modalPrompt('textarea', '回复评论', null, '请输入回复内容').then(function (value) {
        return storeProductReplyComment({
          id: row.id,
          merchantReplyContent: value
        });
      }).then(function () {
        _this4.$message.success('回复成功');
        _this4.load();
      });
    },
    remove: function remove(row) {
      var _this5 = this;
      this.$modalSure('删除当前评论吗？').then(function () {
        return storeProductReplyDelete(row.id);
      }).then(function () {
        _this5.$message.success('删除成功');
        _this5.load();
      });
    },
    clearForm: function clearForm() {
      this.form = this.emptyForm();
      if (this.$refs.form) this.$refs.form.clearValidate();
    }
  }
};